export function pattern_fold({compId,shapeHeight,animationSpeed,flipAnimation}) {
  return `
  <pattern class="patternRepeat" id="pat_${compId}" patternUnits="userSpaceOnUse" height="${shapeHeight}" viewbox="839 0 242 241" x="0" y="0" preserveAspectRatio="xMidYMax meet" width="${shapeHeight}" patternTransform="translate(960 0)">
    <path fill="#ffffff" d="M0-2h840l120,120L1080-2h840v240H0V-2z"/>
    <path fill="url(#paper_fade_${compId})" d="M0-1h840l120,120L1080-1h840v241H0V-1z"/>
    <path fill="white" d="">
    <animate attributeType="xml" attributeName="d"
    values="
      M 840 0 L 870 60 L 960 120 L 840 0 Z;
      M 840 0 L 900 60 L 960 120 L 840 0 Z;
      M 840 0 L 839 122 L 960 120 L 840 0 Z;
      M 840 0 L 839 122 L 960 120 L 840 0 Z;
      M 840 0 L 900 60 L 960 120 L 840 0 Z;
      M 840 0 L 900 60 L 960 120 L 840 0 Z"
    keyTimes="0;0.0625;0.25;0.5;0.6875;1"
    keySplines="0 0 1 1;0.33, 1, 0.68, 1;0 0 1 1;0.32, 0, 0.67, 0;0 0 1 1" calcMode="spline"
     dur="${6 * animationSpeed}s" repeatCount="indefinite" />
    <animate attributeType="xml" attributeName="opacity"
    values="0;0;1;1;0;0"
    keyTimes="0;0.0625;0.25;0.5;0.6875;1"
    keySplines="0 0 1 1;0.33, 1, 0.68, 1;0 0 1 1;0.32, 0, 0.67, 0;0 0 1 1" calcMode="spline"
     dur="${6 * animationSpeed}s" repeatCount="indefinite" />
    </path>
    <path fill="#dddddd" d="">
    <animate attributeType="xml" attributeName="d"
    values="M 840 0 L 960 0 L 960 120 L 840 0 Z;
      M 840 0 L 840 120 L 960 120 L 840 0 Z;
      M 840 0 L 840 120 L 960 120 L 840 0 Z;
      M 840 0 L 960 0 L 960 120 L 840 0 Z;
      M 840 0 L 960 0 L 960 120 L 840 0 Z"
    keyTimes="0;0.25;0.5;0.75;1"
    keySplines="0.37, 0, 0.63, 1;0 0 1 1;0.37, 0, 0.63, 1;0 0 1 1" calcMode="spline"
     dur="${6 * animationSpeed}s" repeatCount="indefinite" />
    </path>

    <path fill="white" d="">
    <animate attributeType="xml" attributeName="d"
    values="
      M 1080 0 L 1050 60 L 960 120 L 1080 0 Z;
      M 1080 0 L 1020 60 L 960 120 L 1080 0 Z;
      M 1080 0 L 1081 122 L 960 120 L 1080 0 Z;
      M 1080 0 L 1081 122 L 960 120 L 1080 0 Z;
      M 1080 0 L 1020 60 L 960 120 L 1080 0 Z;
      M 1080 0 L 1020 60 L 960 120 L 1080 0 Z"
    keyTimes="0;0.0625;0.25;0.5;0.6875;1"
    keySplines="0 0 1 1;0.33, 1, 0.68, 1;0 0 1 1;0.32, 0, 0.67, 0;0 0 1 1" calcMode="spline"
     dur="${6 * animationSpeed}s" repeatCount="indefinite" />
    <animate attributeType="xml" attributeName="opacity"
    values="0;0;1;1;0;0"
    keyTimes="0;0.0625;0.25;0.5;0.6875;1"
    keySplines="0 0 1 1;0.33, 1, 0.68, 1;0 0 1 1;0.32, 0, 0.67, 0;0 0 1 1" calcMode="spline"
     dur="${6 * animationSpeed}s" repeatCount="indefinite" />
    </path>
    <path fill="#dddddd" d="M 1080 0 L 960 0 L 960 120 L 1080 0 Z">
    <animate attributeType="xml" attributeName="d"
    values="M 1080 0 L 960 0 L 960 120 L 1080 0 Z;
      M 1080 0 L 1080 120 L 960 120 L 1080 0 Z;
      M 1080 0 L 1080 120 L 960 120 L 1080 0 Z;
      M 1080 0 L 960 0 L 960 120 L 1080 0 Z;
      M 1080 0 L 960 0 L 960 120 L 1080 0 Z"
    keyTimes="0;0.25;0.5;0.75;1"
    keySplines="0.37, 0, 0.63, 1;0 0 1 1;0.37, 0, 0.63, 1;0 0 1 1" calcMode="spline"
     dur="${6 * animationSpeed}s" repeatCount="indefinite" />
    </path>

    <path fill="white" d="">
    <animate attributeType="xml" attributeName="d"
    values="M 840 0 L 960 0 L 960 120 L 840 0 Z;
      M 840 0 L 840 120 L 960 120 L 840 0 Z;
      M 840 0 L 840 120 L 960 120 L 840 0 Z;
      M 840 0 L 960 0 L 960 120 L 840 0 Z;
      M 840 0 L 960 0 L 960 120 L 840 0 Z"
    keyTimes="0;0.25;0.5;0.75;1"
    keySplines="0.37, 0, 0.63, 1;0 0 1 1;0.37, 0, 0.63, 1;0 0 1 1" calcMode="spline"
     dur="${6 * animationSpeed}s" repeatCount="indefinite" />
    <animate attributeType="xml" attributeName="opacity"
    values="0;0.5;1;0;0;0;0.5;0;0"
    keyTimes="0;0.0625;0.125;0.125;0.375;0.625;0.688;0.75;1"
    keySplines="0 0 1 1;0.33, 1, 0.68, 1;0 0 1 1;0.32, 0, 0.67, 0;0.32, 0, 0.67, 0;0 0 1 1;0 0 1 1;0 0 1 1" calcMode="spline"
     dur="${6 * animationSpeed}s" repeatCount="indefinite" />
    </path>
    <path fill="white" d="">
    <animate attributeType="xml" attributeName="d"
    values="M 1080 0 L 960 0 L 960 120 L 1080 0 Z;
      M 1080 0 L 1080 120 L 960 120 L 1080 0 Z;
      M 1080 0 L 1080 120 L 960 120 L 1080 0 Z;
      M 1080 0 L 960 0 L 960 120 L 1080 0 Z;
      M 1080 0 L 960 0 L 960 120 L 1080 0 Z"
    keyTimes="0;0.25;0.5;0.75;1"
    keySplines="0.37, 0, 0.63, 1;0 0 1 1;0.37, 0, 0.63, 1;0 0 1 1" calcMode="spline"
     dur="${6 * animationSpeed}s" repeatCount="indefinite" />
    <animate attributeType="xml" attributeName="opacity"
    values="0;0.5;1;0;0;0;0.5;0;0"
    keyTimes="0;0.0625;0.125;0.125;0.375;0.625;0.688;0.75;1"
    keySplines="0 0 1 1;0.33, 1, 0.68, 1;0 0 1 1;0.32, 0, 0.67, 0;0.32, 0, 0.67, 0;0 0 1 1;0 0 1 1;0 0 1 1" calcMode="spline"
     dur="${6 * animationSpeed}s" repeatCount="indefinite" />
    </path>

  </pattern>
<mask id="mask_${compId}">
  <rect class="animdiv-mask animdiv-mask-top" width="100%" height="${shapeHeight}" fill="url(#pat_${compId})"></rect>
</mask>
<mask class="flipped" id="mask_single_${compId}">
  <rect class="animdiv-mask animdiv-mask-top" x="50%" width="1920" height="${shapeHeight}" fill="url(#single_${compId})"></rect>
</mask>
`;
}